import { ComponentId } from "@omegagrid/core";
import { Container } from "./container";
import { Command, CommandGroupSource, CommandQuery, CommandSource, CommandsSection, Options } from "@omegagrid/commands";

export type CommandProvider = CommandsSection & {

	getGroups?: (_query?: CommandQuery) => CommandGroupSource[] | Promise<CommandGroupSource[]>;

	getCommands?: (_query: CommandQuery) => CommandSource[] | Promise<CommandSource[]>;

	exec?: (_command: Command, _value?: string) => void;

	getOptions?: () => Options | Promise<Options>;

}


export class Commands {

	readonly providers = new Map<ComponentId, CommandProvider>();

	constructor(readonly container: Container) { }

	registerProvider(provider: CommandProvider) {
		this.providers.set(provider.id, provider);
	}

}

